<template>
  <!--  <div class="positionfixed">-->
  <div class="positionfixed">
    <Header></Header>
    <div v-if="isPageLoaded">
      <div class="NavLeft ailogoNav" style="pointer-events: none;">
        <div class="ailogoNav_left" style="pointer-events: none;opacity: 0"></div>
        <div class="ailogoNav_right" style="pointer-events: auto;">
          <!-- 右侧导航链接，根据当前左侧导航项动态渲染 -->
          <div class="GenerateManagementNav_logo2">
            <div class="GenerateManagementNav_logo_img">
              <img alt="nav_logo_img" :src="picturesAndTextsWithBackground"/>
            </div>
            <div class="GenerateManagementNav_logo_btn" @click="GenerateManagementWindowClass">
              <span><img alt="" src="@a/ailogo/images/sv4on.svg"/></span>切换LOGO
            </div>
          </div>

          <div class="ailogoNav_right_list" style="pointer-events: auto;">
            <router-link v-for="link in links" :key="link.to" :to="getLinkTo(link)"
                         :class="['right_list_li', { 'active-link': isActive(link) }]">
              <div class="list_li_title">
                <div class="li_title_icon">
                <span>
                  <img :alt="link.alt" :src="isActive(link) ? link.iconActive : link.icon"/>
                </span>
                </div>
                <div class="li_title_title">
                  {{ link.baseText }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <router-view :key="$route.fullPath" :picturesAndTextsWithBackground="picturesAndTextsWithBackground"
                   :independentPatternWithBackground="independentPatternWithBackground"
                   :picturesAndTexts="picturesAndTexts" :independentPattern="independentPattern"
                   :svgBaseUrl="svgBaseUrl" :croppedImage="croppedImage" :background="background"
                   :oriImage="oriImage" :title="title" :isSVG="isSVG"></router-view>
    </div>
    <div v-else class="loading">
      加载中，请稍后...
    </div>
    <!-- logo切换弹窗 -->
    <div class="GenerateManagement_Window" :class="{ active: GenerateManagementWindowActive }">
      <div class="GenerateManagement_Window_content">
        <div class="Window_content_title font18">
          选择我的LOGO
          <div class="content_title_back" @click="GenerateManagementWindowClass">
            <img alt="" src="@a/ailogo/images/sv15.svg"/>
          </div>
        </div>
        <div class="Window_content_txt OScroll" @scroll="handleLogoScroll" ref="scrollContainer">
          <!--          <div class="content_txt_list active">-->
          <!--            <div class="txt_list_now font14">当前</div>-->
          <!--            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>-->
          <!--            <div class="txt_list_btn font14">切换logo</div>-->
          <!--          </div>-->
          <!--          <div v-for="(site, siteIndex) in sites" :key="siteIndex"-->
          <!--               :class="['LogoCenterContent_list', { active: activeIndices.includes(siteIndex) }]" ref="listItems">-->
          <div v-for="(site, siteIndex) in sites" :key="siteIndex">

            <div v-for="(image, index) in site.logo" :key="index" class="content_txt_list">
              <div class="txt_list_img">
                <img :src="image.png_url" alt="d"/>
                <div class="txt_list_btn font14" @click="selectImage(image.id,image.png_url,image.is_svg)">切换LOGO
                </div>
              </div>
            </div>
          </div>
          <!--            <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg"/></div>-->


        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Header from '@c/header/header'
import logoFile from './LogoFile.vue';
import {fabric} from "fabric";
import CustomTextbox from "@v/ailogo/fabric/CustomTextbox";


export default {
  data() {
    return {
      picturesAndTextsWithBackground: null,
      canvas: null,
      independentPatternWithBackground: null,
      picturesAndTexts: null,
      independentPattern: null,
      canvasWidth: 1200,
      canvasHeight: 900,
      svgBaseUrl: null,
      isSVG: false,
      croppedImage: null,
      background: null,
      oriImage: null,
      title: null,

      selectedPngUrl: '@a/ailogo/images/bg12.jpg',
      isPageLoaded: false,
      tempId: "1",
      GenerateManagementWindowActive: false,
      jsonData: null,
      links: [
        {
          to: 'LogoFile',
          baseText: 'LOGO文件',
          alt: 'logo',
          icon: require('@/assets/ailogo/img/s7.svg'),
          iconActive: require('@/assets/ailogo/img/s7on.svg'),
        },
        {
          to: 'BusinessCard',
          baseText: '商务名片',
          alt: 'logo',
          icon: require('@/assets/ailogo/img/s8.svg'),
          iconActive: require('@/assets/ailogo/img/s8on.svg'),
        },
        {
          to: 'PrototypeDisplay',
          baseText: '样机展示',
          alt: 'logo',
          icon: require('@/assets/ailogo/img/s9.svg'),
          iconActive: require('@/assets/ailogo/img/s9on.svg'),
        },
        {
          to: 'SocialProfilePicture',
          baseText: '社交头像',
          alt: 'logo',
          icon: require('@/assets/ailogo/img/s10.svg'),
          iconActive: require('@/assets/ailogo/img/s10on.svg'),
        },
        // {
        //   to: 'Slide',
        //   baseText: '幻灯片',
        //   alt: 'logo',
        //   icon: require('@/assets/ailogo/img/s11.svg'),
        //   iconActive: require('@/assets/ailogo/img/s11on.svg'),
        // },
        // {
        //   to: 'LetterheadPaper',
        //   baseText: '信头纸',
        //   alt: 'logo',
        //   icon: require('@/assets/ailogo/img/s12.svg'),
        //   iconActive: require('@/assets/ailogo/img/s12on.svg'),
        // },
      ],
      // 列表与分页
      sites: [],         // 列表数据
      activeIndices: [], // 跟踪所有触碰顶部的元素索引(如果有需要才用)
      currentPage: 1,    // 当前加载的页码
      pageSize: 3,       // 每页加载数量
      totalPages: 0,     // 总页数
      isLoading: false,  // 防止重复加载
      intervalId: null,  // 轮询 ID
    }
  },
  components: {
    Header,
    logoFile
  },
  computed: {},
  async mounted() {
    await this.getImages()

    await this.loadData()

  },
  created() {


  },
  methods: {
    // 裁剪图片
    cropImage() {
      const canvas = new fabric.Canvas('canvas');
      fabric.Image.fromURL(this.picturesAndTexts, (img) => {
        try {
          // 将图片添加到画布
          canvas.add(img);
          canvas.renderAll();

          // 获取图片的像素数据
          const imageElement = img.getElement();
          const tempCanvas = document.createElement('canvas');
          const tempCtx = tempCanvas.getContext('2d');
          tempCanvas.width = imageElement.width;
          tempCanvas.height = imageElement.height;
          tempCtx.drawImage(imageElement, 0, 0);

          const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
          const data = imageData.data;

          // 初始化边界值
          let left = tempCanvas.width;
          let right = 0;
          let top = tempCanvas.height;
          let bottom = 0;

          // 遍历像素数据，找到非透明区域的边界
          for (let y = 0; y < tempCanvas.height; y++) {
            for (let x = 0; x < tempCanvas.width; x++) {
              const alpha = data[(y * tempCanvas.width + x) * 4 + 3]; // 获取 Alpha 值
              if (alpha > 0) { // 如果像素不透明
                if (x < left) left = x;
                if (x > right) right = x;
                if (y < top) top = y;
                if (y > bottom) bottom = y;
              }
            }
          }

          // 计算裁剪区域的宽度和高度
          const width = right - left + 1;
          const height = bottom - top + 1;

          // 创建一个新的画布，用于裁剪
          const croppedCanvas = document.createElement('canvas');
          croppedCanvas.width = width;
          croppedCanvas.height = height;
          const croppedCtx = croppedCanvas.getContext('2d');

          // 将非透明区域绘制到新画布
          croppedCtx.drawImage(
              imageElement,
              left, top, width, height, // 源图像的裁剪区域
              0, 0, width, height // 目标画布的绘制区域
          );

          // 将裁剪后的图片保存到变量中
          this.croppedImage = croppedCanvas.toDataURL({
            format: 'png', // 导出格式
          });

        } catch (error) {
          console.error('裁剪图片时出错:', error);
        }
      }, {
        crossOrigin: 'Anonymous', // 处理跨域问题
        onError: (error) => {
          console.error('图片加载失败:', error);
        }
      });
    },

    /**
     * 加载字体并渲染画布
     * @param  jsonData - 获取字体数据的接口 URL
     */
    async loadFont(jsonData) {
      try {
        // 1. 从接口获取字体数据
        const response = await this.axios.get("api/LogoChoice/getCanvasFont")
        if (response.code !== 1) {
          throw new Error(`接口返回错误: ${data.msg}`);
        }

        const usedFonts = new Set();

        function extractFonts(obj) {
          if (obj.type === 'textbox') {
            usedFonts.add(obj.fontFamily);
          }
          if (obj.objects) {
            obj.objects.forEach(extractFonts);
          }
        }

        extractFonts(jsonData)


        // 2. 提取字体列表
        const fontList = response.result.map(font => ({
          name: font.name,
          file_url: font.file_url.trim() // 去除 URL 中的空格
        }));

        // 3. 加载字体
        const fontPromises = fontList
            .filter(font => usedFonts.has(font.name))
            .map(font => {
              const fontFace = new FontFace(font.name, `url(${font.file_url})`);
              return fontFace.load()
                  .then(loadedFont => {
                    document.fonts.add(loadedFont);
                    console.log(`${font.name} 加载完成`);
                  })
                  .catch(error => {
                    console.error(`${font.name} 加载失败:`, error);
                    throw error; // 抛出错误以便在 Promise.all 中捕获
                  });
            });

        // 等待所有字体加载完成
        await Promise.all(fontPromises);
        console.log('所有字体加载完成');

      } catch (error) {
        console.error('加载字体或渲染画布失败:', error);
        // throw error; // 抛出错误以便外部捕获
      }
    },
    extractBackground(obj) {
      if (obj.type === 'rect') {
        this.background = obj.fill;
      }
      if (obj.objects) {
        obj.objects.forEach(this.extractBackground);
      }
    }
    ,
    extractTitle(obj) {
      if (obj.id === 'title') {
        this.title = obj.text;
      }
      if (obj.objects) {
        obj.objects.forEach(this.extractTitle);
      }
    },
    async loadData() {
      try {
        const response = await this.axios.get(`api/LogoChoice/getLayerJson?image_id=${this.tempId}`);
        // 处理响应数据
        if (response.code === 1) {
          this.jsonData = response.result.details;
        }


        this.extractBackground(this.jsonData)
        this.extractTitle(this.jsonData)


        await this.loadFont(this.jsonData)
        const canvasElement = document.createElement('canvas');
        this.canvas = new fabric.Canvas(canvasElement, {
          width: this.canvasWidth, // 设置画布宽度
          height: this.canvasHeight, // 设置画布高度
        });
        this.picturesAndTextsWithBackground = await this.loadAndConvertToBase64(this.jsonData);
        this.picturesAndTexts = await this.loadAndConvertToBase64(this.transparent(this.jsonData));
        const tmp = this.removeTitleAndCenterImage(this.jsonData)

        this.independentPatternWithBackground = await this.loadAndConvertToBase64(tmp);
        this.independentPattern = await this.loadAndConvertToBase64(this.transparent(tmp));
        await this.loadOriToBase64(this.jsonData)
        this.cropImage();

        // }
      } catch (error) {
        console.error('请求失败:', error);
      }

      if (this.$route.query.svg === "1") {
        this.isSVG = true;
        try {
          const downloadResourceResp = await this.axios.get(`api/LogoChoice/getSvgUrl?image_id=${this.tempId}`);
          if (downloadResourceResp.code === 1) {
            this.svgBaseUrl = downloadResourceResp.result.svg_url
          }
        } catch (error) {
          console.error("请求失败:", error);
        }

      }
    }
    ,
    async loadAndConvertToBase64(jsonData) {
      return new Promise((resolve, reject) => {

        // 使用现有的 canvas 实例加载 JSON 数据
        this.canvas.loadFromJSON(jsonData, () => {
          this.canvas.renderAll();
          // 转换为 Base64 数据
          const pngData = this.canvas.toDataURL({
            format: "png",
            quality: 1,
          });

          resolve(pngData);  // 返回 Base64 数据
        }, (o, object) => {
        });
      });
    }
    ,
    transparent(jsonData) {
      // 深拷贝对象
      let copiedData = JSON.parse(JSON.stringify(jsonData));
      for (let i = 0; i < copiedData.objects.length; i++) {
        if (copiedData.objects[i].id === "workspace") {
          copiedData.objects[i].fill = "rgba(255,255,255,0)";
          break;
        }
      }
      return copiedData;
    }
    ,
    removeTitleAndCenterImage(jsonData) {
      // 创建一个新的 JSON 数据副本
      let inputJson = JSON.parse(JSON.stringify(jsonData));

      // 过滤掉 id 为 "subtitle" 和 "title" 的对象
      inputJson.objects = inputJson.objects.filter(
          obj => obj.id !== "subtitle" && obj.id !== "title"
      );

      // 查找 id 为 "icon" 的对象
      const iconObject = inputJson.objects.find(obj => obj.id === "icon");

      if (iconObject) {
        // 动态计算居中
        iconObject.left = (this.canvasWidth - iconObject.width * iconObject.scaleX) / 2;
        iconObject.top = (this.canvasHeight - iconObject.height * iconObject.scaleY) / 2;
      }

      // 返回更新后的 JSON 数据
      return inputJson;
    }
    ,
    GenerateManagementWindowClass() {
      this.GenerateManagementWindowActive = !this.GenerateManagementWindowActive
    }
    ,
    selectImage(imageId, imageUrl, is_svg) {
      this.tempId = imageId;
      this.selectedPngUrl = imageUrl
      this.GenerateManagementWindowActive = false;
      this.isSVG = is_svg;
      this.$router.replace({
        name: this.$route.name,
        query: {...this.$route.query, svg: is_svg}, // 保留原有参数，添加或覆盖 svg
      });

      this.loadData();
      // this.refresh();
    }
    ,

    async defaultLogoUrl() {
      // 检查data数组是否存在且第一个元素是否有logo数组
      if (this.sites.length > 0 && this.sites[0].logo && this.sites[0].logo.length > 0) {
        this.tempId = this.$route.query.tempId ? this.$route.query.tempId : this.sites[0].logo[0].id
        this.selectedPngUrl = this.sites[0].logo[0].png_url;
        this.isSVG = 1 === this.sites[0].logo[0].is_svg
        if (this.isSVG) {
          try {
            const downloadResourceResp = await this.axios.get(`api/LogoChoice/getSvgUrl?image_id=${this.tempId}`);
            if (downloadResourceResp.code === 1) {
              this.svgBaseUrl = downloadResourceResp.result.svg_url
            }
          } catch (error) {
            console.error("请求失败:", error);
          }
        }

      }
    }
    ,
    isActive(link) {
      return this.$route.path.endsWith(link.to);
    }
    ,
    getLinkTo(link) {
      return {
        path: link.to,
        query: {tempId: this.tempId}  // 加入 tempId 到 query 中
      };

    }
    ,
    refresh() {
      // this.loaddata().then(() => {
      //
      // });

      const vm = this;
      // 检查是否带参数，如果没有参数则动态添加
      vm.$router.replace({
        name: vm.$route.name, // 当前路由名称
        query: {tempId: vm.tempId}, // 添加后台返回的参数
      });

      // window.location.reload()
    }
    ,
    async getImages(page = 1, limit = 3) {
      try {
        this.isLoading = true; // 开始“加载更多”，显示底部 Loading
        const res = await this.axios.get(
            "https://api.ai-dog.net/api/LogoChoice/historyList",
            {params: {page, limit}}
        );

        if (res.code === 1) {
          const {data, current_page, last_page} = res.result;
          this.currentPage = current_page;
          this.totalPages = last_page;
          // 追加新数据
          this.sites = [
            ...this.sites,
            ...data.filter(site => site.status === 2).map(site => ({
              ...site,
              progress: site.status === 1 ? 1 : 1
            }))
          ];
          // 检查是否需要轮询
          // const needsPolling = this.sites.some(site => site.status !== 2);
          // if (needsPolling && !this.intervalId) {
          //   this.startPolling();
          // }


          // 检查是否带参数，如果没有参数则动态添加
          if (!this.$route.query.tempId) {
            await this.defaultLogoUrl()
            this.$router.replace({
              name: this.$route.name, // 当前路由名称
              query: {tempId: this.tempId}, // 添加后台返回的参数
            });
          } else {
            this.tempId = this.$route.query.tempId
          }
          this.isPageLoaded = true
        } else {
          console.error("接口返回错误:", res.msg);
          this.isPageLoaded = true
        }
      } catch (error) {
        console.error("获取站点时出错:", error.message);
      } finally {
        this.isLoading = false; // 结束“加载更多”，隐藏底部 Loading
      }
    }
    ,
    handleLogoScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // 到达底部 => 加载更多
      if (
          scrollTop + clientHeight >= scrollHeight - 10 &&
          !this.isLoading &&
          this.currentPage < this.totalPages
      ) {
        // 这里请求下一页
        this.getImages(this.currentPage + 1, this.pageSize);
      }

      // 检测列表项是否触碰顶部
      // const containerTop = container.getBoundingClientRect().top;
      // this.activeIndices = [];
      // this.$refs.listItems.forEach((item, index) => {
      //   const itemTop = item.getBoundingClientRect().top - 100;
      //   if (itemTop <= containerTop) {
      //     if (!this.activeIndices.includes(index)) {
      //       this.activeIndices.push(index);
      //     }
      //   }
      // });
    }
    ,
    loadOriToBase64(jsonData) {
      if (jsonData.type === 'image') {
        const canvas = new fabric.Canvas(this.$refs.canvas);

        // 使用 Fabric.js 加载图片
        fabric.Image.fromURL(jsonData.src, (img) => {
          // 设置 Canvas 的尺寸为图片的尺寸
          canvas.setWidth(img.width);
          canvas.setHeight(img.height);

          // 将图片添加到 Canvas
          canvas.add(img);

          // 将 Canvas 内容转换为 Base64
          this.oriImage = canvas.toDataURL({
            format: 'png', // 可以设置为 'jpeg' 或 'png'
            quality: 1, // 图片质量，0 到 1
          });
        }, {
          crossOrigin: 'anonymous', // 启用跨域支持
        });
      }
      if (jsonData.objects) {
        jsonData.objects.forEach(this.loadOriToBase64);
      }
    }
  }
}
</script>


<style>
</style>
